import type { TableFilterField } from '@shared/ui';
import type { CompanyFiltersForm } from './types';

export const companyFiltersConfig: TableFilterField[] = [
  {
    name: 'name',
    label: 'Компания',
    type: 'text' as const,
    placeholder: 'Все',
  },
  {
    name: 'createdAt',
    label: 'Дата создания',
    type: 'date-range' as const,
    placeholder: 'Выберите',
  },
  {
    name: 'cityName',
    label: 'Город',
    type: 'select-city' as const,
    placeholder: 'Все',
    apiKey: 'city.name',
  },
  {
    name: 'managerName',
    label: 'Менеджер',
    type: 'text' as const,
    placeholder: 'Все',
    apiKey: 'manager.name',
  },
  {
    name: 'isActive',
    label: 'Статус',
    type: 'select' as const,
    options: [
      { value: 'true', label: 'Активна' },
      { value: 'false', label: 'Неактивна' },
    ],
    clearable: true,
    placeholder: 'Все',
  },
  {
    name: 'nccVerified',
    label: 'NCC подтвержден',
    type: 'select' as const,
    options: [
      { value: 'true', label: 'Подтвержден' },
      { value: 'false', label: 'Не подтвержден' },
      { value: 'null', label: 'Не проверено' },
    ],
    clearable: true,
    placeholder: 'Все',
  },
  {
    name: 'economicActivitiesName',
    label: 'Сфера экономической деятельности',
    type: 'multi-select',
    options: [],
    placeholder: 'Все',
    apiKey: 'economicActivities.name',
    // minWidth: 506,
  },
];

export const initialValues: CompanyFiltersForm = {
  name: '',
  createdAt: [null, null],
  cityName: [],
  economicActivitiesName: [],
  managerName: '',
  isActive: null,
  nccVerified: null,
};
